import { SDKError } from '../types';

export class APIError extends Error {
  constructor(message: string, public code: string, public details?: any) {
    super(message);
    this.name = 'APIError';
  }
}

export async function makeRequest<T>(
  url: string,
  options: RequestInit = {},
  apiKey: string
): Promise<T> {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'X-API-Key': apiKey,
      ...options.headers,
    };

    const response = await fetch(url, {
      ...options,
      headers,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new APIError(
        data.message || 'API request failed',
        data.code || 'REQUEST_FAILED',
        data.details
      );
    }

    return data as T;
  } catch (error) {
    if (error instanceof APIError) {
      throw error;
    }
    throw new APIError(
      'Network request failed',
      'NETWORK_ERROR',
      error instanceof Error ? error.message : error
    );
  }
}

export const DEFAULT_BASE_URL = 'https://cms.datplatform.com';